module.exports = __webpack_public_path__ + "img/succ_icon2.7638a3b9.png";